const buildAssetLabels = (filters) =>
  (filters.availableLabels || []).map((label) => ({
    id: label.uuid,
    title: label.name,
    icon: 'label',
    payload: {
      type_key: 'assetLabelIds',
      object: {
        id: label.id,
      },
    },
  }))

export default buildAssetLabels

const buildLabels = (labelSet, labels = []) => {
  const mappableLabels = labels.map ? labels : Object.values(labels)

  return mappableLabels.map((label) => ({
    id: `label-${label.id}`,
    title: label.name,
    icon: 'label',
    payload: {
      type_key: 'labels',
      object: {
        id: label.id,
        labelSetId: labelSet.id,
      },
    },
  }))
}

const buildLabelSets = (labelSets = []) => {
  const mappableLabels = labelSets.map ? labelSets : Object.values(labelSets)

  return mappableLabels.map((labelSet) => ({
    id: `label-set-${labelSet.id}`,
    title: labelSet.name,
    icon: 'label',
    childOptions: buildLabels(labelSet, labelSet.labels),
  }))
}

export const buildLabelFilters = ({ groupOrAble, inclusive, labelSets }) => ({
  id: 'labels',
  title: 'Labels',
  icon: 'label',
  groupOrAble,
  inclusivity: inclusive,
  childOptions: buildLabelSets(labelSets),
})
